import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import ChangeLog from '@/views/ChangeLog.vue'
import Login from '@/views/Login.vue'
import DownloadArea from '@/views/DownloadArea.vue'
import NotFound from '@/components/error-pages/NotFound'
import store from '@/store'
import Excursions from '@/views/Excursions.vue'
import Stiftungsfest125 from '@/views/Stiftungsfest125.vue'
import Functions from '@/views/Functions.vue'
import Honoratio from '@/views/Honoratio.vue'
import Memory from '@/views/Memory.vue'
import Flyer from '@/views/Flyer.vue'
import About from '@/views/About.vue'
import ExternFAQ from '@/views/ExternFAQ.vue'
import Calendar from '@/views/Calendar.vue'
import Cinema from '@/views/Cinema.vue'
import Credits from '@/views/Credits.vue'
import Advertising from '@/views/Advertising.vue'
import SearchDocs from '@/views/SearchDocs.vue'
import Penalties from '@/views/Penalties.vue'
import AddressUpdate from '@/views/AddressUpdate.vue'
import FileUpload from '@/views/FileUpload.vue'
import Profiles from '@/views/Profiles.vue'
import Tasks from '@/views/Tasks.vue'
import MeetingPlanner from '@/views/MeetingPlanner.vue'
import Presidents from '@/views/Presidents.vue'
import InternFAQ from '@/views/InternFAQ.vue'

// import Countdown from '@/views/Countdown.vue'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/internfaq',
      name: 'internfaq',
      component: InternFAQ,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/changelog',
      name: 'changelog',
      component: ChangeLog,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/downloads',
      name: 'downloads',
      component: DownloadArea,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/excursions',
      name: 'excursions',
      component: Excursions,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/jubilee',
      name: 'jubilee',
      component: Stiftungsfest125,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/dignitaries',
      name: 'dignitaries',
      component: Honoratio,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/memory',
      name: 'memory',
      component: Memory,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/flyer',
      name: 'flyer',
      component: Flyer,
    },
    {
      path: '/faq',
      name: 'faq',
      component: ExternFAQ,
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
    },
    {
      path: '/credits',
      name: 'credits',
      component: Credits,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/meetings',
      name: 'meetings',
      component: MeetingPlanner,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/presidents',
      name: 'presidents',
      component: Presidents,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: Advertising,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/penalties',
      name: 'penalties',
      component: Penalties,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/search',
      name: 'search',
      component: SearchDocs
    },
    {
      path: '/cinema',
      name: 'cinema',
      component: Cinema,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/upload',
      name: 'upload',
      component: FileUpload,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/profiles',
      name: 'profiles',
      component: Profiles,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: Tasks,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/address',
      name: 'address',
      component: AddressUpdate,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/functions',
      name: 'functions',
      component: Functions,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/gallery2020',
      name: 'gallery2020',
      component: () => import(/* webpackChunkName: "gallery2020" */ './views/Gallery2020.vue')
    },
    {
      path: '/gallery2019',
      name: 'gallery2019',
      component: () => import(/* webpackChunkName: "gallery2019" */ './views/Gallery2019.vue')
    },
    {
      path: '/gallery2005',
      name: 'gallery2005',
      component: () => import(/* webpackChunkName: "gallery2005" */ './views/Gallery2005.vue')
    },
    {
      path: '/gallery2003',
      name: 'gallery2003',
      component: () => import(/* webpackChunkName: "gallery2003" */ './views/Gallery2003.vue')
    },
    {
      path: '/gallery1979',
      name: 'gallery1979',
      component: () => import(/* webpackChunkName: "gallery1979" */ './views/Gallery1979.vue')
    },
    {
      path: '/datenschutz',
      name: 'datenschutz',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "datenschutz" */ './views/Datenschutz.vue')
    },
    {
      path: '/impressum',
      name: 'impressum',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "impressum" */ './views/Impressum.vue')
    }
  ]
})
